"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contractStatuses = void 0;
var contractStatuses = [{
  label: 'Employer and employee signed the contract',
  value: 'both_parties_signed'
}, {
  label: 'Contract has been declined',
  value: 'declined'
}, {
  label: 'Employee signed the contract',
  value: 'employee_signed'
}, {
  label: 'Employer signed the contract',
  value: 'employer_signed'
}, {
  label: 'Contract has been issued',
  value: 'issued'
}, {
  label: 'Employee still needs to sign the contract',
  value: 'pending_employee_signature'
}, {
  label: 'Employer still needs to sign the contract',
  value: 'pending_employer_signature'
}, {
  label: 'Contract has been terminated e.g due to expiration date',
  value: 'terminated'
}, {
  label: 'Contract has been deleted by admin',
  value: 'deleted'
}];
exports.contractStatuses = contractStatuses;